export const EXPIRES_IN = 86400;
export const STORAGE_NAMES = {
    auth0SSO: 'auth0',
    returnUrl: 'returnUrl',
    expiresAt: 'expiresAt',
    isLoggedIn: 'isLoggedIn',
    accessToken: 'accessToken',
    bearer: 'bearer',
    idpUuid: 'idpUuid',
    device: 'device',
};
// @deprecated
export const COOKIE_NAMES = {
    returnUrl: 'returnUrl',
    expiresAt: 'expiresAt',
    isLoggedIn: 'isLoggedIn',
};
